module.exports = __webpack_public_path__ + "static/living_room_day-c61c0aa8a3dcb8b4a7d153768ffaf677.jpg";